import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareListClassicRoute: InvariantJiraRoute = {
	name: 'software-list-classic',
	path: '/jira/software/c/projects/:projectKey/list/:navigationItemId?',
};
